import { apiFetch } from "@/lib/api/client";
import type { MailDelivery } from "@/lib/types/api";
import type { Advisor } from "@/lib/types/session";

export function getAdvisorsList(): Promise<Advisor[]> {
  return apiFetch<Advisor[]>("/advisors");
}

export interface SaveAdvisorInput {
  id?: string;
  name: string;
  email: string;
  phone: string;
  avatar: string;
}

export type SaveAdvisorResponse =
  | { advisor: Omit<Advisor, "mustChangePassword"> }
  | { advisor: Advisor; delivery: MailDelivery; initialPassword?: string };

export function saveAdvisor(input: SaveAdvisorInput): Promise<SaveAdvisorResponse> {
  return apiFetch<SaveAdvisorResponse>("/advisors", {
    method: "POST",
    body: JSON.stringify(input)
  });
}

export function deleteAdvisor(advisorId: string): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>(`/advisors/${encodeURIComponent(advisorId)}`, { method: "DELETE" });
}

export function setEmailNotificationsEnabled(enabled: boolean): Promise<{ ok: true; emailNotificationsEnabled: boolean }> {
  return apiFetch<{ ok: true; emailNotificationsEnabled: boolean }>("/advisors/me/notification-prefs", {
    method: "PATCH",
    body: JSON.stringify({ emailNotificationsEnabled: enabled })
  });
}
